/**
* useGetCategory
* @param {String} slug 
* @returns Object
*/
export async function useGetCategory(slug) {
  let pathName = ''
  let id = 1
  const urlMatch = String(slug).match(/^(.*?)-(\d+)$/)
  if (urlMatch) {
    pathName = urlMatch[1]
    id = urlMatch[2]
  } else {
    id = slug
  }

  if (!id) {
    throw createError({
      fatal: true,
      statusCode: 404,
      message: 'Not Found'
    })
  }

  return await useCustomFetch(`/categories/${id}`, {
    key: `category-${id}`,
    headers: {
      'Cache-Control': 's-maxage=60, stale-while-revalidate',
      'Authorization': 'Public'
    },
    onResponse({ response }) {        
      if ((pathName && pathName !== response._data.data?.urlPathName) || response._data.data?.status !== 'published') {
        throw createError({
          fatal: true,
          statusCode: 404,
          message: 'Not Found'
        })
      }
          
      return response
    }
  }, {
    maxAge: 10
  })
}

/**
* useGetProducts
* @param {Number} id 
* @param {Object} params 
* @returns Object
*/
export function useGetProducts(id, params) {
  /*
  * Request Url
  */
  let requestUrl = `/categories/${id}/products`

  if (params.value.type === 'search') {
    requestUrl = '/products'
  }

  /*
  * Request
  */
  return useCustomFetch(requestUrl, {
    key: `products-${id}`,
    query: params,
    headers: {
      'Cache-Control': 's-maxage=60, stale-while-revalidate',
      'Authorization': 'Public'
    },
    server: false,
    transform(input) {
      const productsData = {
        data: {},
        _meta: input?._meta || {}
      }

      input?.data?.products.forEach((product) => {
        if (!productsData.data[product.label]) {
          productsData.data[product.label] = []
        }

        productsData.data[product.label].push(product)
      })
        
      return productsData
    },
    onResponse({ response }) { 
      return response
    }
  })
}
    
/**
* useGetProduct
* @param {String} slug 
* @returns Object
*/
export async function useGetProduct(slug) {
  let pathName = ''
  let id = 1
  const urlMatch = slug.match(/^(.*?)-(\d+)$/)
  if (urlMatch) {
    pathName = urlMatch[1]
    id = urlMatch[2]
  } else {
    id = slug
  }

  if (!id) {
    throw createError({
      fatal: true,
      statusCode: 404,
      message: 'Not Found'
    })
  }

  return await useCustomFetch(`/products/${id}`, {
    key: `product-${id}`,
    headers: {
      'Cache-Control': 's-maxage=60, stale-while-revalidate'
    },
    transform(input) {
      return {
        sections: input?.sections,
        product: Object.assign(input?.data?.product, { breadcrumbs: input?.data?.breadcrumbs }),
        settings: input?.data?.settings,
        global: input?.data?.global,
        _meta: input?._meta || {}
      }
    },
    onResponse({ response }) { 
      if ((pathName && pathName !== response?._data?.data?.product?.producturlpathname) || response?._data?.data?.product?.productstatus !== 'published') {
        throw createError({
          fatal: true,
          statusCode: 404,
          message: 'Not Found'
        })
      }
          
      return response
    }
  }, {
    maxAge: 10
  })
}

/**
* useGetProductSpec
* @param {String} slug 
* @returns Object
*/
export async function useGetProductSpec(slug) {
  let id = 1
  const urlMatch = slug.match(/^(.*?)-(\d+)$/)
  if (urlMatch) {
    id = urlMatch[2]
  } else {
    id = slug
  }

  if (!id) {
    throw createError({
      statusCode: 404,
      message: 'Not Found'
    })
  }

  return await useCustomFetch(`/customers/customization/specification/${id}/no-designer`, {
    key: `productSpec-${id}`,
    headers: {
      'Cache-Control': 's-maxage=60, stale-while-revalidate',
      'Authorization': 'Public'
    }
  }, {
    maxAge: 10
  })
}